import { useEffect, useState } from "react";
import http from "@/api";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { TrendingUp } from "lucide-react";

// Dashboard de Desempeño: tendencia histórica del score derivado (global y por categoría)
export default function TrendsPanel() {
  const [data, setData] = useState(null);
  const [cat, setCat] = useState("__all__");

  useEffect(() => {
    http.get("/dashboard/trends").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data || (data.periods || []).length < 2) return null;

  const cats = Array.from(new Set(data.periods.flatMap((p) => Object.keys(p.by_category || {})))).sort();
  const series = data.periods.map((p) => ({
    period: p.period,
    score: cat === "__all__" ? p.score : (p.by_category?.[cat] ?? null),
  }));

  return (
    <div className="sketch-border bg-[var(--cream-soft)] p-6 mb-10" data-testid="trends-panel">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-3">
        <div>
          <div className="font-hand text-xl text-[var(--lala-blue)] flex items-center gap-2">
            <TrendingUp size={16} /> desempeño histórico
          </div>
          <h3 className="font-display text-2xl">Evolución del score por periodo</h3>
          <p className="text-xs text-[var(--ink-soft)] mt-1">
            Score derivado de las capturas de KPIs (escala 0–10). Solo lectura — vista de desempeño para liderazgo.
          </p>
        </div>
        <select value={cat} onChange={(e) => setCat(e.target.value)} className="input-field max-w-[220px]"
          data-testid="trends-category-select">
          <option value="__all__">Global (todas las categorías)</option>
          {cats.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div className="bg-white rounded-xl border border-[var(--line)] p-3" style={{ height: 260 }}>
        <ResponsiveContainer width="100%" height={236} minWidth={200} minHeight={160} initialDimension={{ width: 520, height: 236 }}>
          <LineChart data={series}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E1E4EE" />
            <XAxis dataKey="period" tick={{ fontSize: 11 }} />
            <YAxis domain={[0, 10]} tick={{ fontSize: 11 }} />
            <Tooltip />
            <Line type="monotone" dataKey="score" stroke="#0033AD" strokeWidth={2.5}
              dot={{ r: 3, fill: "#0033AD" }} connectNulls name="Score" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
